module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "dsbn-header"
  }, [_c('div', {
    staticClass: "brand"
  }, [_c('svg-icon', {
    attrs: {
      "clazz": "sm-hidden dsbn-logo",
      "path": "dsbn-horizontal.svg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "adventure-logo",
    attrs: {
      "src": _vm.adventure_campus_logo,
      "alt": ""
    }
  })], 1), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', [_c('div', {
    staticClass: "sm-hidden",
    attrs: {
      "link": ""
    }
  }, [_c('a', {
    attrs: {
      "href": "."
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('div', {
    staticClass: "sm-hidden",
    attrs: {
      "link": ""
    }
  }, [_c('a', {
    attrs: {
      "href": "#about"
    }
  }, [_vm._v("About")])]), _vm._v(" "), _c('div', {
    staticClass: "sm-hidden",
    attrs: {
      "link": ""
    }
  }, [_c('a', {
    attrs: {
      "href": "#contact"
    }
  }, [_vm._v("Contact")])]), _vm._v(" "), _c('div', {
    attrs: {
      "button": "",
      "link": ""
    }
  }, [_c('a', {
    attrs: {
      "href": "https://bookadventure.dsbn.org"
    }
  }, [_vm._v("Book")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fc6e4006","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/tags/DSBNHeader.vue
// module id = 381
// module chunks = 0